import React from 'react';

import OldAddress from '../sections/OldAddress';
import EndDate from '../sections/EndDate';

export const Terminate: React.FunctionComponent = () => (
  <>
    <OldAddress />
    <EndDate />
  </>
);

export default Terminate;
